import React, { useState, useContext, useEffect } from 'react'
import PropTypes from 'prop-types'
import { requestProfile } from './utils'
import { useGetToken } from '../hooks/useGetToken'
import { DEFAULT_PERMISSIONS } from '../constants/permissions'

const SaveContext = React.createContext()

function SaveProvider({ children }) {
  const { token } = useGetToken()
  const [isSaved, setIsSaved] = useState(true)
  const [profileEmail, setProfileEmail] = useState('')
  const [userProfile, setUserProfile] = useState(null)
  const [fetchProfileError, setFetchProfileError] = useState('')
  const [profileUpdated, setProfileUpdated] = useState(null)
  const [isLoading, setIsLoading] = useState(true)
  const [userPermissions, setUserPermissions] = useState(DEFAULT_PERMISSIONS)
  const [permissionsQuantity, setPermissionsQuantity] = useState(0)

  const updateProfile = async () => {
    try {
      setIsLoading(true)
      setFetchProfileError('')
      await requestProfile(
        token,
        setUserProfile,
        setUserPermissions,
        setPermissionsQuantity,
        setIsLoading,
        setFetchProfileError
      )
      setIsLoading(false)
    } catch (error) {
      setIsLoading(false)
      setFetchProfileError(error.message)
    }
  }

  const value = {
    isSaved,
    setIsSaved,
    isLoading,
    setIsLoading,
    userProfile,
    setUserProfile,
    profileEmail,
    setProfileEmail,
    profileUpdated,
    setProfileUpdated,
    fetchProfileError,
    setFetchProfileError,
    userPermissions,
    permissionsQuantity,
    updateProfile
  }

  useEffect(() => {
    updateProfile()
  }, [token])

  return <SaveContext.Provider value={value}>{children}</SaveContext.Provider>
}

function useSave() {
  const context = useContext(SaveContext)
  if (context === undefined) {
    throw new Error('useSave must be used within a SaveProvider')
  }
  return context
}

export { SaveProvider, useSave }

SaveProvider.propTypes = {
  children: PropTypes.node
}
